import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure12 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#4573be', '#6fad56'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [ "Belgique 2016", "Italie 2016", "Autriche 2016", "Allemagne 2016", "Espagne 2016", "Finlande 2016", "Danemark 2016", "Luxembourg 2016", "Grèce 2016", "Slovaquie 2016", "Suède 2016", "Chypre 2016", "Lituanie 2016", "Pays-Bas 2016", "Canada 2016", "Roumanie 2016", "Croatie 2016", "France 2016", "Slovénie 2016", "Estonie 2016", "Irlande 2016", "Tchéquie 2016", "Pologne 2016", "Malte 2016", "Portugal 2016", "Bulgarie 2016", "Lettonie 2016", "Hongrie 2016", "Guinée-Bissau 2019", "Géorgie 2020", "Bénin 2019", "Sénégal 2019", "Mali 2017", "Inde 2012", "Togo 2019", "Burkina Faso 2019", "Niger 2014", "Éthiopie 2019", "République-Unie de Tanzanie 2015", "Ouganda 2016", "Nigéria 2019", "Malawi 2020" ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 180.0,
        min: 0,
        tickInterval: 20,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: 'Hommes petits producteurs alimentaires',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 130.5, 132.7, 158.4, 119.0, 103.8, 109.4, 105.7, 107.5, 77.4, 80.5, 99.7, 79.1, 79.6, 73.6, 90.8, 74.2, 69.3, 65.3, 64.9, 69.6, 62.2, 63.9, 59.0, 78.1, 56.2, 50.8, 55.3, 46.3, 10.6, 12.9, 11.6, 10.3, 13.7, 6.7, 6.9, 5.7, 4.6, 5.1, 4.1, 3.7, 5.2, 2.1 ],
      },
      {
        name: 'Femmes petits producteurs alimentaires',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 130.8, 128.4, 114.9, 101.9, 88.1, 87.1, 84.7, 82.3, 74.6, 74.0, 73.9, 70.9, 69.8, 69.5, 68.7, 67.3, 61.5, 60.8, 58.4, 57.8, 55.7, 53.6, 52.6, 51.1, 50.1, 49.8, 49.4, 43.6, 16.6, 12.0, 11.1, 10.6, 8.0, 7.3, 6.4, 5.6, 5.1, 4.4, 3.8, 3.3, 3.3, 1.8, ]
      }
    ]
}